import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=86d55c68&scoped=true&"
import script from "./ProfileTabs.vue?vue&type=script&lang=ts&"
export * from "./ProfileTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTabs.vue?vue&type=style&index=0&id=86d55c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d55c68",
  null
  
)

export default component.exports